import React from 'react';

const About = () => {
    return (
        <div>
            This is the About component
        </div>
    );
};

export default About;